import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./routes/index";
import { setPersistence, onAuthStateChanged, browserLocalPersistence } from "firebase/auth";

// Font Awesome
import "./fontawesome.js";

// Bootstrap
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@comlinedev/bootstrap4/dist/css/bootstrap.css";

import { auth } from "./firebase"

Vue.use(BootstrapVue);
Vue.config.productionTip = true;

// App Init
setPersistence(auth, browserLocalPersistence).then(() => {
  onAuthStateChanged(auth, (user) => {
    store.dispatch("fetchUser", user);
    let app = "";
    if (!app) {
      app = new Vue({
        render: (h) => h(App),
        router,
        store,
      });
      app.$mount("#app");
    }
  });
});
